import { render, staticRenderFns } from "./FiltersSections.vue?vue&type=template&id=3e053dd1&scoped=true"
import script from "./FiltersSections.ts?vue&type=script&lang=ts&external"
export * from "./FiltersSections.ts?vue&type=script&lang=ts&external"
import style0 from "./FiltersSections.vue?vue&type=style&index=0&id=3e053dd1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e053dd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e053dd1')) {
      api.createRecord('3e053dd1', component.options)
    } else {
      api.reload('3e053dd1', component.options)
    }
    module.hot.accept("./FiltersSections.vue?vue&type=template&id=3e053dd1&scoped=true", function () {
      api.rerender('3e053dd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/FiltersSections/FiltersSections.vue"
export default component.exports